import { createContext } from 'react'

const shipStationContext = createContext()

export default shipStationContext
